/*global BMap BMAP_STATUS_SUCCESS BMAP_ANIMATION_DROP*/

import { makeMarkerHtml } from "@/components/Map/utils/marker";
import { myConst, myFn, myMap } from "@/config/";
import rootStore from "@/store/";
const { appStore, dataStore, mapStore } = rootStore;
import { toggleInfoBox } from "@/components/Map/utils/infoBox";


export const mapData = {
    noLocMarker: "",
    succMarker: "", // 我的位置 Marker 定位时赋值
    circle: "", // 我的定位位置 范围圈 定位时赋值
    singleTap: 0, // 地图每次点击次数 单击还是双击
    mapClickEventTimer: "", // 地图点击事件定时器 用来判断单击还是双击还是啥
    nearMarker: [],
    lastCenterLoc: { // 初始值为经纬度 后覆盖为百度地图 Point 类
        lat: 0,
        lng: 0,
    },
};
mapData.lastCenterLoc = new BMap.Point(mapData.lastCenterLoc.lng, mapData.lastCenterLoc.lat);


export function init() {
    if (!appStore.initState.page) {
        // 第一次 初始化
        findAndPin(mapStore.defaultLoc.bLoc);
    } else {
        myMap.map.clearOverlays();
        const centerPoint = myMap.map.getCenter();
        mapData.nearMarker = [];
        findAndPin(centerPoint);
    }
}
export function findAndPin(centerPoint) {
    const dataList = dataStore.dataList;
    const disArr = dataList.map((v, i) => ({
        item: v,
        distance: myMap.map.getDistance(v.bLoc, centerPoint),
    }))
        .sort((a, b) => a.distance - b.distance)
        .slice(0, myConst.maxShowInMap)
        .map(v => v.item);
    // 优化 减少 Dom CRUD
    const addPinMarkerArr = [];
    const onMapMarkerArr = [];
    const removePinMarkerArr = [];
    // 找出新增的 marker 和地图上已有的 marker
    for (let i = 0; i < disArr.length; i++) {
        const disMarker = disArr[i];
        let flag = false;
        for (let j = 0; j < mapData.nearMarker.length; j++) {
            let nMarker = mapData.nearMarker[j];
            if (nMarker.id == disMarker.id) {
                flag = true;
                break;
            }
        }
        if (flag === false) {
            // 在地图上没找到一样的，说明这是要新增的
            addPinMarkerArr.push(disMarker);
        } else {
            onMapMarkerArr.push(disMarker);
        }
    }
    myFn.pin(addPinMarkerArr);
    const infoBoxState = myMap.infoBoxState;

    // 找出需要删除的
    for (let i = 0; i < mapData.nearMarker.length; i++) {
        let nMarker = mapData.nearMarker[i];
        if (infoBoxState.lastOpen + 1000 > Date.now() && nMarker.id === infoBoxState.openMarker.id) {
            // infoBox 打开触发的保留点
            continue;
        }
        let flag = false;
        for (let j = 0; j < onMapMarkerArr.length; j++) {
            let onMapMarker = onMapMarkerArr[j];
            if (nMarker.id == onMapMarker.id) {
                flag = true;
                break;
            }
        }
        if (flag == false) {
            // 没找，说明这是要删除的
            removePinMarkerArr.push(nMarker);
        }
    }
    removePinMarkerArr.forEach(v => {
        myMap.map.removeOverlay(v.marker);
    });


    if (myMap.infoBox._isOpen) {
        // 如果 infoBox 已经打开，但是 marker 不在范围 则关闭 infoBox
        if (infoBoxState.lastOpen + 1000 > Date.now()) {
            //如果打开 infoBox 1s内就触发了 moveend 导致 findAndPin
            // 说明是 infoBox 的移动动画导致的， 这时候不关闭infoBox
            // 把 infoBox 的 marker 加到地图上的点里面去用于下次判断(disArr->nearMarker)
            const inTheArr = disArr.some(v => infoBoxState.openMarker.id === v.id);
            if (!inTheArr) disArr.push(infoBoxState.openMarker);
        } else {
            toggleInfoBox({ source: 'findAndPin', on_off: false });
        }
    }
    // if (myMap.infoBox._isOpen) {
    //     // 如果 infoBox 已经打开，但是 marker 不在范围 则关闭 infoBox
    //     const openInfoMarker = myMap.infoBoxState.openMarker;
    //     const inTheArr = disArr.some(v => openInfoMarker.id === v.id);
    //     if (!inTheArr) toggleInfoBox({ source: 'findAndPin', on_off: false });
    // }
    // 保存附近的marker
    mapData.nearMarker = disArr;
}

// 优化 不用每次重新生成
const icon = new BMap.Icon("./static/img/dot.jpg", new BMap.Size(41, 30));
const bSize = new BMap.Size(0, -30);
export function pin(arr) {
    const map = myMap.map;
    console.red('Add pin Marker', arr.length);
    arr.forEach((v, i) => {
        if (!v.marker) {
            const marker = new BMap.Marker(v.bLoc, { icon });
            const label = new BMap.Label();
            const html = makeMarkerHtml(v, 'pin');
            label.setContent(html);
            label.setOffset(bSize);
            label.setStyle({
                backgroundColor: "rgba(255, 255, 255, 0)",
                border: 0,
            });
            v.label = label;
            v.marker = marker;
        }
        v.marker.setLabel(v.label);
        map.addOverlay(v.marker);
    });
}
export function getMyLocInit() {
    // 创建一个未定位标记
    mapData.noLocMarker = new BMap.Marker(mapStore.defaultLoc.bLoc, {
        title: "我的位置",
        enableMassClear: false,
        icon: new BMap.Icon("./static/img/location/noLoc.png", new BMap.Size(16, 16)),
    });
    myMap.map.addOverlay(mapData.noLocMarker);
    myMap.geolocation = new BMap.Geolocation();
    // 定位回调函数赋值
    myMap.geolocation.getLoc = function () {
        if (appStore.locState.isLocIng) return;
        appStore.changeIsLocIng(true);
        myMap.geolocation.getCurrentPosition(function (position) {
            if (this.getStatus() === BMAP_STATUS_SUCCESS && position.latitude && position.longitude) {
                const inCurrentCity = position.address.city.includes(myConst.city);
                if (!position.accuracy) position.accuracy = 100;
                console.blue('定位城市', position.address.city);
                const myLoc = mapStore.myLoc = {
                    lat: position.latitude,
                    lng: position.longitude,
                    accuracy: position.accuracy,
                    bLoc: position.point,
                    address: position.address,
                };
                // 画点
                if (!mapData.succMarker) {
                    // 初始化
                    mapData.succMarker = new BMap.Marker(myLoc.bLoc, {
                        icon: new BMap.Icon("./static/img/location/succ.png", new BMap.Size(30, 30)),
                        title: "我的位置",
                        enableMassClear: false,
                    });
                    // _this.succMarker.disableMassClear();
                    mapData.succMarker.setTop(true);
                    mapData.succMarker.setAnimation(BMAP_ANIMATION_DROP);
                    myMap.map.addOverlay(mapData.succMarker);
                    //指南针
                    getNorth(mapData.succMarker);
                } else {
                    mapData.succMarker.setPosition(myLoc.bLoc);
                }
                // TODO 百度地图Api诡异的bug  circle.setRadius 不会清除原来的 Radius,  导致 Radius一直重叠
                // TODO 所以这里每次重新生成 circle 对长按后的监听 会有一点点的性能影响
                myMap.map.removeOverlay(mapData.circle);
                mapData.circle = null;
                // 范围
                if (!mapData.circle) {
                    mapData.circle = new BMap.Circle(myLoc.bLoc, myLoc.accuracy, {
                        fillColor: "rgba(144, 202, 249, 0.5)",
                        strokeColor: "rgba(144, 202, 249, 1)",
                        strokeWeight: 2,
                        enableMassClear: false,
                    });
                    myMap.map.addOverlay(mapData.circle);
                    // 用来测试 bug
                    // setTimeout(() => {
                    //     mapData.circle.setRadius(500);
                    // }, 3000)
                } else {
                    // TODO 处理完上面的 BUG 这里才会生效
                    mapData.circle.setCenter(myLoc.bLoc);
                    mapData.circle.setRadius(myLoc.accuracy);
                }
                if (inCurrentCity) {
                    console.green(`定位成功 在${myConst.city}`);
                    myMap.map.removeOverlay(mapData.noLocMarker);
                    myMap.map.panTo(myLoc.bLoc);
                    mapStore.setMyLoc(myLoc);
                } else {
                    console.blue(`定位成功 不在${myConst.city}`);
                    window.mdui.snackbar({ message: `定位成功,但您好像不在${myConst.city}` });
                    // err();
                }
                appStore.changeLocState(true);
            } else {
                console.red('定位失败');
                window.mdui.snackbar({ message: '定位失败' });
                appStore.changeLocState(false);
                // err();
            }
            //定位结束
            appStore.changeIsLocIng(false);
        }, {
            enableHighAccuracy: true,
            timeout: myConst.loc.timeout,
            maximumAge: myConst.loc.maximumAge,
        });
    };
    //开始定位
    myMap.geolocation.getLoc();

    // function err() {
    // 没定位到该咋办
    // }
}

// 我的坐标是指南针
function getNorth(succMarker) {
    // 指针
    if (window.DeviceOrientationEvent) {
        // console.log('your browser is prefer to support DeviceOrientationEvent');
        window.addEventListener("deviceorientation", findNorth);
        // eslint-disable-next-line
        function getOrientationData(evt) {
            return {
                'alphaValue': evt.alpha,
                'betaValue': evt.beta,
                'gammaValue': evt.gamma,
            };
        }
        // eslint-disable-next-line
        function showInScreen(data) {
            if (data.alphaValue) {
                let deg = -data.alphaValue;
                succMarker.setRotation(deg);
            }
        }
        // eslint-disable-next-line
        function findNorth(evt) {
            let me = evt;
            showInScreen(getOrientationData(me));
        }
    } else {
        console.red('不支持指南针');
    }
}
